import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { parseUTC } from 'core/utils';

import LoginModalHoc from 'core/hoc/LoginModalHoc';
import MerchantReply from 'core/components/MerchantReply';
import TruncatedContent from 'core/components/TruncatedContent';
import { ThumbVoting } from 'core/components/Voting';
import { FlexRow } from 'core/styles';

import {
	Author,
	AnswerBody,
	AnswerWrapper,
	AnswerVotingContainer,
	CustomerAnswer,
} from './questionsStyles';


class Answer extends PureComponent {
	handleVote = (upVote) => {
		this.props.onVote(upVote);
	}

	render() {
		const { id, customerId, body, author, official, helpful, notHelpful, activeVote, createdAt, onToggle } = this.props;
		const postDate = format(parseUTC(createdAt), 'LLLL yyyy');
		return (
			<AnswerWrapper data-id={id}>
				{official ? (
					<LoginModalHoc>
						{({ triggerLoginModal }) =>
							<MerchantReply
								postDate={postDate}
								displayName={author}
								verb={'answered'}
								onToggle={onToggle}
								footer={(
									<ThumbVoting
										upVotes={helpful}
										downVotes={notHelpful}
										onVote={this.handleVote}
										activeVote={activeVote}
									/>
								)}
								triggerLogin={triggerLoginModal}
								isLoggedIn={!!customerId}>
								{body}
							</MerchantReply>
						}
					</LoginModalHoc>
				) : (
					<CustomerAnswer>
						<AnswerBody>
							<TruncatedContent visibleWordCount={80} onToggle={onToggle}>
								{body}
							</TruncatedContent>
						</AnswerBody>
						<FlexRow centered spaceBetween>
							<Author>{`by ${author}, ${postDate}`}</Author>
							<AnswerVotingContainer>
								<ThumbVoting
									upVotes={helpful}
									downVotes={notHelpful}
									onVote={this.handleVote}
									activeVote={activeVote}
								/>
							</AnswerVotingContainer>
						</FlexRow>
					</CustomerAnswer>
				)}
			</AnswerWrapper>
		);
	}
}

Answer.propTypes = {
	id: PropTypes.number.isRequired,
	customerId: PropTypes.number,
	body: PropTypes.string.isRequired,
	author: PropTypes.string.isRequired,
	official: PropTypes.bool,
	helpful: PropTypes.number,
	notHelpful: PropTypes.number,
	activeVote: PropTypes.oneOf(["up", "down"]),
	createdAt: PropTypes.string.isRequired,
	onVote: PropTypes.func.isRequired,
	onToggle: PropTypes.func,
};

Answer.defaultProps = {
	helpful: 0,
	notHelpful: 0,
	activeVote: null,
	onToggle: null,
};

export default Answer;
